<template>
    <div id="userAddRegistForm" class="base">
        <div class="title-area">
            <div style="font-size: 24px; color: whitesmoke">Philips Care Portal</div>    
            <div style="font-size: 24px; color: whitesmoke">申込みフォーム </div>
        </div>
        <div v-if="isLoading" class="regist-area">
        </div>
        <div v-else-if="isQueryError" class="regist-area">
            <div id="item-contens">
                <div class="card-content">
                    <div style="font-size: 20px; color: whitesmoke">URLエラー</div>
                    <div style="color: whitesmoke">
                        指定されたページはURLが間違っているか、有効期限が切れています。
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="isAgreed == false" class="agreement-area">
            <div id="item-contens">
                <div class="card-content ">
                    <div>
                        <span style="font-size:20px; color:whitesmoke;">利用規約</span>
                        <a @click="download"><b-icon style="margin-top:3px; color:whitesmoke;" icon="file-download-outline"/></a>
                    </div>                    
                    <table>
                        <tr><td><textarea readonly class="cautionArea noresize" v-model="agreement" /></td></tr>
                        <tr><td><div  style="text-align: center;"><b-checkbox class="cstmCheckBox" v-model="isAgree" :disabled="!canAgree">利用規約に同意のうえ、申込みを行う。</b-checkbox></div></td>
                        </tr>
                    </table>
                </div>
            </div>
            <b-button class="opbutton" @click="agree" :disabled="!isAgree">申込みを行う</b-button>
        </div>
        <!--#68対応_20250417
        <div v-else-if="isAuthentication == false" class="regist-area">
            <div id="item-contens">
                <div class="card-content">
                    <div style="font-size: 20px; color: whitesmoke">認証ワードを入力してください。</div>
                    <table >
                        <tr><th style="width:180px;"></th><td></td></tr>
                        <tr><th style="width:180px;">認証ワード<span class="require" /></th><td><input type="text" v-model="authentication" minlength="4" maxlength="100" class="validate" name="認証ワード" validate="required"/></td></tr>
                        <tr><th style="width:180px;"></th><td></td></tr>
                    </table>
                </div>
            </div>
            <b-button class="authenticationCheckButton" @click="authenticationCheck" :disabled="!authentication">本人認証を実施する</b-button>
        </div>
        -->
        <div v-else-if="isRegist == false" class="regist-area">
            <div id="item-contens">
                <div class="card-content">
                    <div style="font-size: 20px; color: whitesmoke">ユーザー情報を入力してください。</div>
                    <table >
                        <tr><th>メールアドレス</th><td><input type="text" v-model="data.mail" id="mail" name="メールアドレス" validate="required|mail" disabled/></td></tr>
                        <tr><th>ユーザー名<span class="require" /></th>
                        <td><input type="text" class="nameInput" v-model="data.lastName" id="lastName" name="ユーザー名(姓)" validate="required" maxlength="50" placeholder="姓"/>
                            <input type="text" class="nameInput" v-model="data.firstName" id="firstName" name="ユーザー名(名)" validate="required" maxlength="50" placeholder="名"/>
                        </td>
                        </tr>
                        <tr><th>ユーザー名（カナ）<span class="require" /></th>
                        <td><input type="text" class="nameInput" v-model="data.lastNameKana" id="lastNameKana" name="ユーザー名(姓カナ)" validate="required|kana" maxlength="50" placeholder="セイ"/>
                            <input type="text" class="nameInput" v-model="data.firstNameKana" id="firstNameKana" name="ユーザー名(名カナ)" validate="required|kana" maxlength="50" placeholder="メイ"/>
                        </td>
                        </tr>
                        <tr/>
                        <tr><th>パスフレーズ認証</th><td><b-checkbox class="cstmCheckBox" v-model="data.passphraseFlag" id="passphraseFlag">二段階認証を行う</b-checkbox></td></tr>
                        <template v-if="data.passphraseFlag">
                        <tr>
                            <th>　送信先(携帯番号)</th>
                            <td><input type="text" class="passInput" v-model="data.passphraseSendNo" id="passphraseSendNo" name="送信先(携帯番号)" validate="numeric" maxlength="20" placeholder="ハイフン(-)なし。例)09012345678"/><b-button class="passButton" @click="sendTestSMS" :disabled="!isActive">テスト送信</b-button></td>
                        </tr>
                        <tr>
                            <th>　送信先(Eメールアドレス)</th>
                            <td><input type="text" class="passInput" v-model="data.passphraseSendMail" id="passphraseSendMail" name="送信先(Eメールアドレス)" validate="mail" maxlength="256" placeholder="例) example@example.co.jp"/><b-button class="passButton" @click="sendTestMail" :disabled="!isActive">テスト送信</b-button></td>
                        </tr>
                        </template>
                    </table>
                </div>
            </div>
            <b-button class="opbutton" icon-left="offer" @click="regist" :disabled="!isActive">申込み</b-button>
        </div>
        <div v-else class="regist-area">
            <div id="item-contens">
                <div class="card-content">
                    <div style="font-size: 18px; color: whitesmoke; margin:20px 0;">
                        登録の申し込みが完了しました。<br>
                    </div>
                    <div style="font-size: 13px; color: whitesmoke; margin:20px 30px;text-align: left;">
                        ※システムへの登録が完了しましたら、登録済みメールアドレスに登録完了メールが送付されます。<br>
                        登録完了メールが届きましたらメール本文に記載されているURLにアクセスし、登録済みメールアドレスおよび初期パスワードを使ってログインしてください。<br>
                        ※初期パスワードは登録完了メールに記載されております。<br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {consentStatement} from "@/components/mock/base/const.js";

export default {
  name: "userAddRegistForm",
  data() {
    var query = this.$route.query.key
    //初期値
    var data = {
        mail:"",
        lastName:"",
        firstName:"",
        lastNameKana:"",
        firstNameKana:"",
        passphraseFlag:false,
        passphraseSendNo:"",
        passphraseSendMail:"",
        belongsId:""
    }
    return {
        query,
        isLoading: true,
        isQueryError:true,
        agreement:null,
        canAgree:false,
        isAgree: false,
        isAgreed: false,
        isAuthentication: false,
        isRegist:false,
        authentication: "",
        data,
        isActive: true,
        token:"",
        applicantId:0
    };
  },
  methods: {
    agree: function() {
        //this.isAgreed = true;
        this.authenticationCheck();
    },
    authenticationCheck: function() {
        // バリデーションチェック
        var elements = document.getElementsByClassName("validate")
        var result = this.selfMadeValidation(elements)
        var errMsg = result.msg
        if(result.isError){
            this.showErrorMessage(errMsg)
            return
        } else if (errMsg != ""){
            this.showErrorMessage(errMsg)
        }else {
            this.$store.dispatch("authenticationCheckPOST", {
                authentication: this.authentication,
                key: this.query
            }).then(result => {
                if(result != null && result.status === 200 ) {
                    this.data.belongsId = result.body.belongsId;
                    this.token = result.body.token;
                    this.applicantId = result.body.applicantId;
                    this.isAuthentication = true;
                    this.isAgreed = true;
                } else if (result != null && (result.status === 400 || result.status === 401 || result.status === 500)){
                    var message = "予期しないエラーが発生しました。"
                    if(result.response && result.response.body && result.response.body.message){
                        message = result.response.body.message
                    } else if(result.message){
                        message = result.message
                    }
                    this.showErrorMessage(message)
                } else {
                    this.showErrorMessage("予期しないエラーが発生しました。") 
                }
            });
        }
    },
    download: function(){
        this.$store.dispatch("downloadConsentStatement", {
            type: consentStatement.registPage,
            uid: 0
        }).then(result => {
            if(!result.status || result.status != 200){
                if(result.obj){
                    this.showErrorMessage(result.obj.message);
                } else {
                    this.showErrorMessage(result.message);
                }
            }
        }).catch(error => {
            this.showErrorMessage(error);
        });
    },
    sendTestSMS: function(){
        if(this.data.passphraseSendNo != ""){
            var checkFields = [document.getElementById("passphraseSendNo")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                    passphraseSendMail:"",
                    passphraseSendNo:this.data.passphraseSendNo
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
            this.showErrorMessage("送信先(携帯番号)を入力してください。")
        }
    },
    sendTestMail: function(){
        if(this.data.passphraseSendMail != ""){
            var checkFields = [document.getElementById("passphraseSendMail")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                passphraseSendMail:this.data.passphraseSendMail,
                    passphraseSendNo:""
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
            this.showErrorMessage("送信先(Eメールアドレス)を入力してください。")
        }
    },
    sendTest: function(param){
        this.isActive = false;
        try {
            this.$store.dispatch("sendTest", {
              token: this.token,
              contactAddress: param.passphraseSendMail,
              contactPhoneNumber: param.passphraseSendNo
            }).then(result => {
                console.log(result);
                if(result != null && result.status === 200 ) {
                    this.showMessage("メッセージを送信しました。<br>指定した宛先にメッセージが届いていることを確認してください。") 
                } else {
                    this.showErrorMessage(result.message) 
                }
            }).catch(error => {
                console.log(error);
                this.showErrorMessage("予期しないエラーが発生しました。")
            });
        } catch(err){
            console.log(error);
            this.showErrorMessage("予期しないエラーが発生しました。")
        } finally {
            this.isActive = true;
        }
    },
    regist: function() {
        if(this.checkInput()){
            // 登録用API
            this.$store.dispatch("registration", {
                token: this.token,
                mail: this.data.mail,
                lastName: this.data.lastName,
                firstName: this.data.firstName,
                lastNameKana: this.data.lastNameKana,
                firstNameKana: this.data.firstNameKana,
                passPhrase: this.data.passphraseFlag,
                passPhone: this.data.passphraseSendNo,
                passMail: this.data.passphraseSendMail,
                belongsId:this.data.belongsId,
                applicantId:this.applicantId
            }).then(result => {
                if(result != null && result.status === 200 ) {
                    this.isRegist = true;
                } else if (result != null && (result.status === 400 || result.status === 401 || result.status === 500)){
                    var message = "予期しないエラーが発生しました。"
                    if(result.response.body){
                        message = result.response.body.message
                    } else if(result.message){
                        message = esult.message
                    }
                    this.showErrorMessage(message)
                } else {
                    this.showErrorMessage("予期しないエラーが発生しました。")
                }
            });
        }
    },
    checkInput: function(){
        var ret = true;
        var checkFields = [];
        //権限に関係ない共通のチェック
        checkFields.push(document.getElementById("mail"));
        checkFields.push(document.getElementById("lastName"));
        checkFields.push(document.getElementById("firstName"));
        checkFields.push(document.getElementById("lastNameKana"));
        checkFields.push(document.getElementById("firstNameKana"));
        if(this.data.passphraseFlag){
            checkFields.push(document.getElementById("passphraseSendNo"));
            checkFields.push(document.getElementById("passphraseSendMail"));      
        }
        var result = this.selfMadeValidation(checkFields)
        var errMsg = result.msg
        //相関チェック
        if(this.data.passphraseFlag){
            var passphraseSendNoElm = document.getElementById("passphraseSendNo");
            var passphraseSendMailElm = document.getElementById("passphraseSendMail");
            if (passphraseSendNoElm.value == "" && passphraseSendMailElm.value == ""){
                errMsg = errMsg + "送信先(携帯番号)または、送信先(Eメールアドレス)を入力してください。\n"
                passphraseSendNoElm.style["border-color"] = "red";
                passphraseSendMailElm.style["border-color"] = "red";             
            }
        }
        if(errMsg != ""){
            this.showErrorMessage(errMsg);
            ret = false;
        }
        return ret;
    }
  },
  computed: {
  },
  mounted: function(){
     //backgroundの変更
    document.documentElement.style.background = "rgb(0, 114, 218)";
    //keyの検証
    try {
        this.$store.dispatch("verifyKey", {
            key: this.query
        }).then(result => {
            console.log(result);
            if(result != null && result.status === 200 ) {
                this.isQueryError = false;
                this.data.mail = result.body.mail;
            }
            this.getBrunchList();
            this.isLoading = false;
        }).catch(error => {
            this.isLoading = false;
        });
    } catch(err){
        this.isLoading = false;
    }
    this.$store.dispatch("getConsentStatement", {
        type: consentStatement.registPage,
    }).then(result => {
      this.agreement ="利用規約が登録されていません。"
      if(result != null && result.status === 200 ) {
        if(result.body.contents != ""){
            this.agreement = result.body.contents;
            this.canAgree = true;
        }
      }
    }).catch(error => {
        this.agreement ="利用規約を取得できませんでした。"
    });
  }
};
</script>
<style lang="scss" scoped>
.base {
    padding-bottom: 50px;
}
.title-area{
    padding-top:50px;
    margin-bottom:25px;
}
.regist-area{
    width: 600px;
}
.auth-area {
    width: 300px;
}
.regist-area,
.auth-area {
    margin : 0 auto;
}
.card-content {
    border-color: whitesmoke !important;
    margin-bottom:5px;
}
.agreement-area {
    margin : 0 auto;
    width:1000px;
    height:400px;
}
.card-content table th,
.card-content table td,
.cstmCheckBox:hover
{
    color: whitesmoke !important;
}
.regist-area > input,
.auth-area > input{
    margin-bottom:10px;
}
.authFaild{
    margin-top:5px;
    color:tomato;
}
.require::after{
    color:tomato;
}
.opbutton {
    margin-top:10px;
    width: 150px;
}
.authenticationCheckButton {
    margin-top:10px;
    width: 200px;
}
.innerButton{
  margin-top:10px;
}
.nameInput {
  width: 176px !important;
}
.passInput {
  width: 250px !important;
}
.passButton {
  margin-left:5px;
  width:100px !important;
  height:29px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/mock/guest/regist/userAddRegistForm.vue